import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteModeCtx = createContext({ mode: null, modeData: {}, bypassed: true, ready: true });

const isLocalhost = () => {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1";
};

function checkBypassed(data) {
  const hostname = window.location.hostname;
  if (isLocalhost()) return true;
  const params = new URLSearchParams(window.location.search);
  const bypassParam = (data && data.site_bypass_param) || "wa_preview";
  const allowlist = (data && data.site_bypass_allowlist) || [];
  if (params.has(bypassParam)) return true;
  if (allowlist.some((h) => hostname === h || hostname.endsWith("." + h))) return true;
  return false;
}

export function SiteModeProvider({ children }) {
  const [mode, setMode] = useState(null);
  const [modeData, setModeData] = useState({});
  // localhost is always bypassed — app renders immediately, no blank wait
  const [bypassed, setBypassed] = useState(isLocalhost());
  const [ready, setReady] = useState(isLocalhost());

  useEffect(() => {
    let cancelled = false;
    api.get("/settings")
      .then(({ data }) => {
        if (cancelled) return;
        const bypass = checkBypassed(data);
        setBypassed(bypass);
        if (!bypass) {
          if (data.coming_soon_mode) {
            setMode("coming_soon");
            setModeData({ title: data.coming_soon_title, message: data.coming_soon_message });
          } else if (data.maintenance_mode) {
            setMode("maintenance");
            setModeData({ title: data.maintenance_title, message: data.maintenance_message, eta: data.maintenance_eta });
          }
        }
      })
      .catch(() => { /* fail open — show the site if we can't fetch settings */ })
      .finally(() => { if (!cancelled) setReady(true); });

    return () => { cancelled = true; };
  }, []);

  return (
    <SiteModeCtx.Provider value={{ mode, modeData, bypassed, ready }}>
      {children}
    </SiteModeCtx.Provider>
  );
}

export const useSiteMode = () => useContext(SiteModeCtx);
